import React, { useRef } from 'react';
import { type UIAnalyticsEvent, useAnalyticsEvents } from '@atlaskit/analytics-next';
import { DropdownItem, type DropdownItemProps } from '@atlaskit/dropdown-menu';
import {
	withConnectHost,
	isConnectDialogWebItem,
} from '@atlassian/jira-connect-utils/src/common/utils/ecosystem-connect-host.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

type MeatballMenuItemLinkProps = DropdownItemProps & {
	name?: string;
	role?: string;
	id?: string;
	rel?: string;
	styleClass?: string;
	menuItemId: string;
	actionSubjectId?: string;
	onClick: (event: React.MouseEvent | React.KeyboardEvent) => void;
};

export const MeatballMenuItemLink = ({
	rel,
	target,
	styleClass = '',
	onClick,
	href,
	menuItemId,
	actionSubjectId = 'meatballMenu',
	children,
	...props
}: MeatballMenuItemLinkProps): React.JSX.Element => {
	const webItemLinkRef = useRef<HTMLElement | null>(null);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent: UIAnalyticsEvent = createAnalyticsEvent({
		action: 'clicked',
	});
	const onClickWebItem = (e: React.MouseEvent | React.KeyboardEvent) => {
		withConnectHost((connectHost) => {
			if (webItemLinkRef.current && styleClass && href) {
				connectHost.triggerWebItem(webItemLinkRef.current, styleClass, href);
			}
		});
		if (isConnectDialogWebItem(styleClass)) {
			e.preventDefault();
			e.stopPropagation();

			fireUIAnalytics(analyticsEvent, 'dropdownItem clicked', actionSubjectId, {
				menuItemId,
			});
		} else {
			onClick(e);
		}
	};
	return (
		<DropdownItem
			rel={(rel ?? target === '_blank') ? 'noopener noreferrer' : ''}
			target={target}
			onClick={onClickWebItem}
			ref={(ref) => {
				if (ref) {
					webItemLinkRef.current = ref;
				}
			}}
			href={href}
			{...props}
		>
			{children}
		</DropdownItem>
	);
};
